/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Model'];
const factory = function (Model) {
  class SubscriptionPlan extends Model {
    static initClass() {
      this.prototype.$idName = 'planId';

      this.prototype.$resource = 'billing';
    }

    // overrides to prevent usage
    $put() {}
    $fetch() {}
    $post() {}
    $delete() {}
  }
  SubscriptionPlan.initClass();

  return SubscriptionPlan;
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.subscriptionPlan', moduleDeps)
  .factory('SubscriptionPlan', factory);
